export default {"src":"/_next/static/media/kominfo-icon.4e23a8b1.svg","height":60,"width":60};